/**
 * How the Cloudflare Turnstile box appears on a form.
 *
 * "interaction-only" keeps the widget hidden unless Cloudflare decides the
 * visitor has to click something; most visitors are verified without seeing
 * it. The default, "always", drew the box (and Cloudflare's branding) inside
 * every protected form, popups included. Ben's decision, 2026-09-24
 * (docs/popup-experiment-factors_research.md §4): lab studies put CAPTCHA
 * solve times at 3.7-9.8 s and abandonment at up to 30%, and the check runs
 * the same either way.
 *
 * Option name and values: https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/
 * (`appearance`: "always" | "execute" | "interaction-only"; as a data
 * attribute, `data-appearance`).
 *
 * Every render site reads this constant; tests/guard/turnstile-appearance.test.ts
 * fails on one that does not.
 */
export const TURNSTILE_APPEARANCE = "interaction-only" as const;
